export enum MenuOptions {
  CLASSES = "classes",
  PROGRAMS = "programs",
}
